import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  getRole,
  getPlant,
  getPh3,
  updatePassword,
  unlockUser,
  activeUser,
  postFileExcel
} from "./userAPI";

const initialState = {
  data: [],
  dataRole: [],
  dataPlant: [],
  dataPh3: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchAll = createAsyncThunk("user/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response;
});
export const fetchPh3 = createAsyncThunk("user/fetchPh3", async (payload) => {
  const response = await getPh3(payload);
  return response;
});
export const fetchRole = createAsyncThunk("user/fetchRole", async (payload) => {
  const response = await getRole(payload);
  return response;
});

export const fetchPlant = createAsyncThunk(
  "user/fetchPlant",
  async (payload) => {
    const response = await getPlant(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("user/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const addItem = createAsyncThunk("user/addItem", async (payload) => {
  console.log(payload, "payload");
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk("user/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});

export const resetPassword = createAsyncThunk(
  "user/reset-password",
  async ({ id, params }) => {
    const response = await updatePassword(id, params);
    return response;
  }
);

export const unlockUserUpdate = createAsyncThunk(
  "user/unlockUserUpdate",
  async (payload) => {
    const response = await unlockUser(payload);
    return response;
  }
);

export const activeUserUpdate = createAsyncThunk(
  "user/activeUserUpdate",
  async (payload) => {
    const response = await activeUser(payload);
    return response;
  }
);

export const uploadFileExcel = createAsyncThunk(
  "invoice/uploadFileExcel",
  async ({ file }) => {
    const response = await postFileExcel(file);
    return response;
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchPh3.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPh3.fulfilled, (state, action) => {
        state.loading = false;
        state.dataPh3 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        state.loading = false;
        state.dataRole = action.payload.data.data;
      })
      .addCase(fetchPlant.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPlant.fulfilled, (state, action) => {
        state.loading = false;
        state.dataPlant = action.payload.data.data;
      })
      .addCase(activeUserUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(activeUserUpdate.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(unlockUserUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(unlockUserUpdate.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(uploadFileExcel.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadFileExcel.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadExcel = action.payload.data;
      });
  },
});

export const { resetData, setSelected } = userSlice.actions;

export const selectData = (state) => state.user.data;
export const selectDataRole = (state) => state.user.dataRole;
export const selectDataPlant = (state) => state.user.dataPlant;
export const selectDataId = (state) => state.user.dataId;
export const selectLoading = (state) => state.user.loading;
export const selectError = (state) => state.user.error;
export const selectPageNo = (state) => state.user.pageNo;
export const selectPageSize = (state) => state.user.pageSize;
export const selectTotalRecord = (state) => state.user.totalRecord;
export const selectSelected = (state) => state.user.selected;
export const selectResult = (state) => state.user.result;
export const selectDataPh3 = (state) => state.user.dataPh3;

export default userSlice.reducer;
